/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useDispatch, useSelector } from 'react-redux';
import { setWorkspaceGroups } from 'src/store/workspaces/workspaces/actions';
import { toast } from 'src/utils/notification';
import { predefinedColors, predefinedIcons } from '../../settings/settings';
import { WorkspaceService } from 'src/api/services/workspaces/Service.workspace';


const WorkspaceGroupDialog = ({ visible, onClose, selectedGroup }) => {
  const dispatch = useDispatch<any>();
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [icon, setIcon] = useState('');
  const [locked, setLocked] = useState(null);
  const [useIcon, setUseIcon] = useState(false);
  const workspaces = useSelector((state: any) => state.workspaces);
  const group = workspaces.groups.find(g => g.uuid === selectedGroup?.uuid);

  useEffect(() => {
    const source = group?.uuid ? group : JSON.parse(localStorage.getItem('activeWorkspace'));
    setName(source.name || '');
    setColor(source.color || '');
    setUseIcon(!!source.icon);
    setIcon(source.icon || '');
    setLocked(source.locked || false);
    if(source.locked) {
      toast.warning('Workspace is locked!');
      onClose();
    }
  }, [selectedGroup]);

  const handleSave = async () => {
    if (!name.trim()) return toast.warning('Name darf nicht leer sein');

    const base = group || JSON.parse(localStorage.getItem('activeWorkspace') || '{}');
    const updated = { ...base, name: name.trim(), color, icon: useIcon ? icon : '' };

    if (!group) localStorage.setItem('activeWorkspace', JSON.stringify(updated));

    const workspaceService = new WorkspaceService();
    await workspaceService.update(updated);
    dispatch(setWorkspaceGroups((await workspaceService.getAll())));
    onClose();
  };

  if(locked === null) return;

  return (
    <DialogComponent
      visible={locked ? false : visible}
      header="Gruppe bearbeiten"
      showCloseIcon
      isModal
      width="340px"
      target="#root"
      close={onClose}
      zIndex={2000}
      buttons={[
        { click: onClose, buttonModel: { content: 'Abbrechen', cssClass: 'e-custom modal-dialog-btn' } },
        { click: handleSave, buttonModel: { content: 'Speichern', isPrimary: true, cssClass: 'e-custom modal-dialog-btn' } }
      ]}
    >
      <div className="px-4">
        <div className="mb-4">
          <label className="block mb-1 text-sm text-gray-700">Name</label>
          <TextBoxComponent value={name} placeholder="Gruppenname" input={(e) => setName(e.value)} />
        </div>

        <div className="mb-4">
          <label className="block mb-1 text-sm text-gray-700">Farbe</label>
          <div className="flex items-center gap-2 flex-wrap">
            {predefinedColors.map((c) => (
              <div
                key={c}
                onClick={() => setColor(c)}
                className={`w-6 h-6 rounded-full cursor-pointer border ${
                  color === c ? 'border-gray-700 ring-2 ring-gray-700' : 'border-transparent'
                }`}
                style={{ backgroundColor: c }}
              ></div>
            ))}
          </div>
        </div>

        <div className="mt-4">
          <label className="inline-flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={useIcon}
              onChange={() => {
                setUseIcon(!useIcon);
                if (!useIcon && !icon) setIcon(predefinedIcons[0]);
              }}
            />
            Icon verwenden
          </label>
        </div>

        <div
          className={`transition-all duration-300 ${
            useIcon ? 'block visible opacity-100 h-auto mb-4' : 'hidden opacity-0 h-0 overflow-hidden'
          }`}
        >
          <div className="flex flex-wrap gap-2 max-h-[250px] overflow-y-auto mt-2">
            {predefinedIcons.map((i) => (
              <button
                key={i}
                type="button"
                onClick={() => setIcon(i)}
                className={`rounded w-8 h-8 flex items-center justify-center transition border ${
                  icon === i ? 'border-gray-700 bg-gray-100 shadow-inner' : 'border-transparent'
                }`}
                title={i}
              >
                <span className={`e-icons e-${i} text-xl text-gray-700`} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </DialogComponent>
  );
};

WorkspaceGroupDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object
};

export default WorkspaceGroupDialog;
